import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="legal">
      <div className="legal-inner">
        <span className="legal-label">// Legal</span>
        <h1 className="legal-title">Terms of Service</h1>
        <p className="legal-updated">Last updated: June 2026</p>
        <Link to="/" className="legal-back">← Back to Home</Link>

        <div className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the aXtion Technologies website or any of our products and
            services, including aXtion Telemed, aXtion EHR Systems, aXtion Students Portal,
            Fintech Integration, and Enterprise Software Solutions, you agree to be bound by
            these Terms of Service. If you do not agree, please do not use our website or
            services.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. Use of Our Services</h2>
          <ul>
            <li>You agree to use our website and services only for lawful purposes and in accordance with these Terms.</li>
            <li>You are responsible for maintaining the confidentiality of any account credentials associated with our platforms.</li>
            <li>You agree not to misuse, interfere with, or attempt unauthorized access to our systems or data.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. Intellectual Property</h2>
          <p>
            All content on this website, including text, graphics, logos, and software, is the
            property of aXtion Technologies or its licensors and is protected by applicable
            intellectual property laws. You may not reproduce, distribute, or create derivative
            works without our prior written consent.
          </p>
        </div>

        <div className="legal-section">
          <h2>4. Service Availability</h2>
          <p>
            We strive to maintain high availability across our platforms, including emergency
            support availability. However, we do not guarantee uninterrupted access and are not
            liable for downtime caused by factors beyond our reasonable control, including
            scheduled maintenance, third-party outages, or force majeure events.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Healthcare, Education & Financial Data</h2>
          <p>
            Where our platforms process protected health information, student records, or
            financial data on behalf of clients, such data is handled in accordance with
            applicable regulations (including HIPAA, FERPA, and PCI-DSS) and any separate
            agreements executed between aXtion Technologies and the client organization.
          </p>
        </div>

        <div className="legal-section">
          <h2>6. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, aXtion Technologies shall not be liable for
            any indirect, incidental, special, or consequential damages arising from your use of
            our website or services.
          </p>
        </div>

        <div className="legal-section">
          <h2>7. Changes to These Terms</h2>
          <p>
            We may update these Terms of Service from time to time. Continued use of our website
            or services after changes are posted constitutes acceptance of the revised terms.
          </p>
        </div>

        <div className="legal-section">
          <h2>8. Contact Us</h2>
          <p>
            If you have questions about these Terms of Service, please contact us at{' '}
            <a href="mailto:info@axtiontechnologies.com">info@axtiontechnologies.com</a> or call{' '}
            <a href="tel:+17035777500">+1 703-577-7500</a>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsOfService;
